module.exports = __webpack_public_path__ + "rotary_left.svg?e7708af219a7e085983685012d49bb11";


//////////////////
// WEBPACK FOOTER
// ./src/assets/diving_icons/rotary_left.svg
// module id = 208
// module chunks = 0